/** The weekly gift's prizes, apart from the board so they test without Pixi. */

/** One prize, as the server sends it. */
export interface WeeklyGiftPrize {
  index: number;
  coins: number;
  gems: number;
  /** Percent. */
  chance: number;
}

/** "1,000 coins", "25 gems", "500 coins and 10 gems". */
export function prizeText(p: Pick<WeeklyGiftPrize, 'coins' | 'gems'>): string {
  const parts: string[] = [];
  if (p.coins > 0) parts.push(`${p.coins.toLocaleString('en-GB')} coins`);
  if (p.gems > 0) parts.push(`${p.gems.toLocaleString('en-GB')} ${p.gems === 1 ? 'gem' : 'gems'}`);
  return parts.join(' and ');
}

/** The rarest prizes get the big celebration. */
export function isRare(p: WeeklyGiftPrize, prizes: readonly WeeklyGiftPrize[]): boolean {
  const least = Math.min(...prizes.map((q) => q.chance));
  return p.chance > 0 && p.chance <= least;
}


/**
 * The wheel's order: coins and gems taking turns, commonest first, with the
 * rarest prizes spread round it (as near opposite as the count allows).
 * Indexes into `prizes`, clockwise from the top.
 */
export function wheelOrder(prizes: readonly WeeklyGiftPrize[]): number[] {
  const all = prizes.map((_, i) => i);
  const byChance = (a: number, b: number) => prizes[b]!.chance - prizes[a]!.chance;
  const rare = all.filter((i) => isRare(prizes[i]!, prizes)).sort((a, b) => prizes[a]!.gems - prizes[b]!.gems);
  const coins = all.filter((i) => !rare.includes(i) && prizes[i]!.gems === 0).sort(byChance);
  const gems = all.filter((i) => !rare.includes(i) && prizes[i]!.gems > 0).sort(byChance);
  const out: number[] = [];
  while (coins.length || gems.length) {
    if (coins.length) out.push(coins.shift()!);
    if (gems.length) out.push(gems.shift()!);
  }
  const total = out.length + rare.length;
  rare.forEach((i, j) => out.splice(Math.round(((j + 1) * total) / rare.length) - 1, 0, i));
  return out;
}
